import React from 'react';
import { useSelector } from 'react-redux';
import { Fieldset, FormRadio, FormSelect } from '~/components/FormControl';
import { formLabel } from '~/utils/helpers';
import { Form } from 'react-bootstrap';

function PhaseEffectCheck() {
    const { mainPhases } = useSelector((state) => state.heroSaga.trait);

    return (
        <Fieldset className={'px-2'}>
            <Fieldset.Legend>{formLabel('PhaseEffectCheck')}</Fieldset.Legend>
            <Form.Row>
                <FormSelect
                    name="mainPhases"
                    sm={6}
                    options={mainPhases}
                />
                <FormRadio
                    name="isEffectStartedThisTurn"
                    sm={6}
                />
            </Form.Row>
            <Form.Row className="mt-3">
                <FormRadio
                    name="isEffectStartedThisRound"
                    sm={6}
                />
            </Form.Row>
        </Fieldset>
    );
}

export default PhaseEffectCheck;
